<template>
  <div
    class="project-header project-inner w-nav"
    :style="{ backgroundColor: color || DEFAULT_COLOR }"
  >
    <div class="header-container">
      <slot />
    </div>
    <div class="w-nav-overlay" />
  </div>
</template>

<script>
  import { DEFAULT_COLOR } from '@/utils/constants/common';

  export default {
    name: 'ProjectHeader',
    props: {
      color: { type: String },
    },
    data() {
      return { DEFAULT_COLOR };
    },
  };
</script>
